import styled from "styled-components"

import * as SelectPrimitive from "@radix-ui/react-select"
import { LuChevronDown, LuChevronUp, LuCheck } from "react-icons/lu";

export const SelectTriggerStyled = styled(SelectPrimitive.Trigger)`
  display: flex;
  padding-top: 1.5rem;
  padding-bottom: 0.5rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  justify-content: space-between;
  align-items: center;
  border-radius: 0.5rem 0.5rem 0 0;
  border: 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray500};
  background: ${({ theme }) => theme.colors.gray100};
  color: ${({ theme }) => theme.colors.gray500};
  width: 100%;
  height: 3.5rem;
  font-size: 1rem;
  line-height: 1.5rem;
  --tw-ring-offset-color: inherit;
  box-shadow: 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-shadow);
  font-weight: 700;
`

export const SelectValueStyled = styled(SelectPrimitive.Value)`
`

export const SelectScrollUpButtonStyled = styled(SelectPrimitive.ScrollUpButton)``

export const SelectScrollDownButtonStyled = styled(SelectPrimitive.ScrollDownButton)``

export const SelectSeparatorStyled = styled(SelectPrimitive.Separator)`
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
  margin-left: -0.25rem;
  margin-right: -0.25rem;
  height: 1px;
`

export const SelectContentStyled = styled(SelectPrimitive.Content)`
  overflow: hidden;
  position: relative;
  background: white;
  width: 100%;
  @media (min-width: 724px) {
    width: 383px;
  }
  z-index: 50;
  border-radius: 0.375rem;
  border-width: 1px; 
  max-height: 24rem; 
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06); 
  
`

export const SelectViewportStyled = styled(SelectPrimitive.Viewport)`
  width: 100%;
`

export const SelectLabelStyled = styled(SelectPrimitive.Label)`
  padding-top: 0.375rem;
  padding-bottom: 0.375rem; 
  padding-right: 0.5rem; 
  padding-left: 2rem; 
  font-size: 1rem;
  line-height: 1.5rem; 
  font-weight: 600; 
`

export const SelectItemStyled = styled(SelectPrimitive.Item)`
  display: flex;
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  padding-right: 1rem;
  padding-left: 1rem;
  align-items: center;
  border-radius: 0.125rem;
  gap: 2rem;
  outline-style: none;
  width: 100%;
  font-size: 1rem;
  line-height: 1.5rem;
  cursor: default;
  user-select: none;
  border-bottom: 1px solid #e5e5e5;

  &:valid:not(:last-child) {
    border-bottom: 1px solid #e5e5e5 
  }
`

export const ChevronDown = styled(LuChevronDown)`
  height: 1rem;
  width: 1rem;
  ${({ transparent }) => transparent ? "opacity: 0.5;": "" }
`

export const ChevronUp = styled(LuChevronUp)`
  height: 1rem;
  width: 1rem;
  ${({ transparent }) => transparent ? "opacity: 0.5;": "" }
`
export const Check = styled(LuCheck)`
  height: 1rem;
  width: 1rem;
`